export default "__VITE_ASSET__a26ee62c__"